import {
  exists,
  GetSlideDaysRequest,
  GetSlideDaysRequestFromJSON,
  HTTPQuery,
  SlideDate,
  UpdateSlideDaysRequest,
  UpdateSlideDaysRequestFromJSON
} from '@/api'
import * as runtime from '../runtime'

export class SlideDaysApi extends runtime.BaseAPI {
  /**
   *
   * 返却予定日スライド日取得
   * @param request
   */
  async getSlideDays(request: GetSlideDaysRequest): Promise<SlideDate[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetSlideDaysRequestFromJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/slide-days', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      exists(jsonValue, 'days')
        ? jsonValue.days.map(function(date: any): SlideDate {
            return {
              from: date.from,
              to: date.to
            }
          })
        : []
    ).value()
  }

  /**
   *
   * 返却予定日スライド日更新
   * @param request
   */
  async updateSlideDays(
    request: UpdateSlideDaysRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSlideDaysRequestFromJSON(
      request
    )
    const response = await this.requestPut('/slide-days', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
